import React from 'react';
import { Fish, FilledStar, StarEmpty } from '../../assets/icons';
import '../../assets/css/elements/testimonial.css';

const Testimonial = ({
    image,
    rating,
    comment,
    name,
    position
}) => {
    const renderStars = () => {
        return Array(5).fill().map((_, index) => (
            <span key={index} className="star">
                {index < rating ? <img src={FilledStar} alt="" /> : <img src={StarEmpty} alt="" />}
            </span>
        ));
    };

    return (
        <div className="testimonial-card">
            {/* <div className="testimonial-header">
                <img src={image} alt={name} className="testimonial-image" />
                <div className="icon-overlay">
                    <img src={Fish} className="fish-icon" />
                </div>
            </div> */}
            
            <div className="testimonial-content">
                <div className="rating">
                    {renderStars()}
                </div>
                
                <p className="comment">{comment}</p>

                <div className='testimonial-footer'>
                    <div className="testimonial-header">
                        <img src={image} alt={name} className="testimonial-image" />
                        <div className="icon-overlay">
                            <img src={Fish} alt="" className="fish-icon" />
                        </div>
                    </div>
                    <div className="author">
                        <h4 className="name">{name}</h4>
                        <p className="position">{position}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonial;